__turbopack_context__.v({
  "bars": "Header-module__ldgnoG__bars",
  "barsBlackColor": "Header-module__ldgnoG__barsBlackColor",
  "barsClose": "Header-module__ldgnoG__barsClose",
  "barsWhiteColor": "Header-module__ldgnoG__barsWhiteColor",
  "catelogMenu": "Header-module__ldgnoG__catelogMenu",
  "dactive": "Header-module__ldgnoG__dactive",
  "dscroll": "Header-module__ldgnoG__dscroll",
  "dtoggle": "Header-module__ldgnoG__dtoggle",
  "error": "Header-module__ldgnoG__error",
  "headerSearch": "Header-module__ldgnoG__headerSearch",
  "headerSection": "Header-module__ldgnoG__headerSection",
  "headerSectionBlackColor": "Header-module__ldgnoG__headerSectionBlackColor",
  "headerSectionBlackColorError": "Header-module__ldgnoG__headerSectionBlackColorError",
  "headerSectionDBlock": "Header-module__ldgnoG__headerSectionDBlock",
  "headerSectionDNone": "Header-module__ldgnoG__headerSectionDNone",
  "headerSectionEBBPadding": "Header-module__ldgnoG__headerSectionEBBPadding",
  "headerSectionHeight0": "Header-module__ldgnoG__headerSectionHeight0",
  "headerSectionHeight20": "Header-module__ldgnoG__headerSectionHeight20",
  "headerSectionMobileHeight0": "Header-module__ldgnoG__headerSectionMobileHeight0",
  "headerSectionOrder1": "Header-module__ldgnoG__headerSectionOrder1",
  "headerSectionOrder2": "Header-module__ldgnoG__headerSectionOrder2",
  "headerSectionPadding": "Header-module__ldgnoG__headerSectionPadding",
  "headerSectionWhiteColor": "Header-module__ldgnoG__headerSectionWhiteColor",
  "headerSectionWhiteColorError": "Header-module__ldgnoG__headerSectionWhiteColorError",
  "item": "Header-module__ldgnoG__item",
  "logo": "Header-module__ldgnoG__logo",
  "menu": "Header-module__ldgnoG__menu",
  "menuBlackColor": "Header-module__ldgnoG__menuBlackColor",
  "msgBlock": "Header-module__ldgnoG__msgBlock",
  "search": "Header-module__ldgnoG__search",
  "show": "Header-module__ldgnoG__show",
  "subMenu": "Header-module__ldgnoG__subMenu",
  "subscribe": "Header-module__ldgnoG__subscribe",
  "subscribeNL": "Header-module__ldgnoG__subscribeNL",
  "success": "Header-module__ldgnoG__success",
  "textBox": "Header-module__ldgnoG__textBox",
  "toggle": "Header-module__ldgnoG__toggle",
  "toggleDInBlock": "Header-module__ldgnoG__toggleDInBlock",
  "toggleDNone": "Header-module__ldgnoG__toggleDNone",
  "vhidden": "Header-module__ldgnoG__vhidden",
});
